import {
  FETCH_ACADEMIC_FAILURE,
  FETCH_ACADEMIC_REQUEST,
  FETCH_ACADEMIC_SUCCESS,
} from 'constants/academic';
import { DELETE_FILE_REQUEST, DELETE_FILE_SUCCESS } from 'constants/documents';
import {
  VALIDATE_FIELDS_REQUEST,
  VALIDATE_FIELDS_SUCCESS,
} from 'constants/fields';
import {
  UPDATE_IP_COUNTRY_CODE_REQUEST,
  UPDATE_IP_COUNTRY_CODE_SUCCESS,
} from 'constants/geolocation';
import {
  FETCH_OFFER_FAILURE,
  FETCH_OFFER_REQUEST,
  FETCH_OFFER_SUCCESS,
  FETCH_OFFERS_FAILURE,
  FETCH_OFFERS_REQUEST,
  FETCH_OFFERS_SUCCESS,
  FETCH_RECURRING_OFFERS_FAILURE,
  FETCH_RECURRING_OFFERS_REQUEST,
  FETCH_RECURRING_OFFERS_SUCCESS,
  UPDATE_OFFER_DISCOUNT_SUCCESS,
} from 'constants/offers';
import {
  ADD_COUPON_FAILURE,
  ADD_COUPON_REQUEST,
  ADD_REDEEM_REWARDS_FAILURE,
  ADD_REDEEM_REWARDS_REQUEST,
  CREATE_ORDER_FAILURE,
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  DELETE_COUPON_FAILURE,
  DELETE_COUPON_REQUEST,
  DELETE_REDEEM_REWARDS_FAILURE,
  DELETE_REDEEM_REWARDS_REQUEST,
  FETCH_ORDER_FAILURE,
  FETCH_ORDER_OWNERSHIP_FAILURE,
  FETCH_ORDER_OWNERSHIP_REQUEST,
  FETCH_ORDER_OWNERSHIP_SUCCESS,
  FETCH_ORDER_REQUEST,
  FETCH_ORDER_SUCCESS,
  UPDATE_ORDER_FAILURE,
  UPDATE_ORDER_REQUEST,
  UPDATE_ORDER_SUCCESS,
} from 'constants/orders';
import {
  CANCEL_PAYMENT_FAILURE,
  CANCEL_PAYMENT_REQUEST,
  CANCEL_PAYMENT_SUCCESS,
  CREATE_PAYMENT_FAILURE,
  CREATE_PAYMENT_FROM_ORDER_FAILURE,
  CREATE_PAYMENT_FROM_ORDER_REQUEST,
  CREATE_PAYMENT_FROM_ORDER_SUCCESS,
  CREATE_PAYMENT_REQUEST,
  CREATE_PAYMENT_SUCCESS,
  FETCH_DOCUMENTS_COLLECTIONS_FAILURE,
  FETCH_DOCUMENTS_COLLECTIONS_REQUEST,
  FETCH_DOCUMENTS_COLLECTIONS_SUCCESS,
  FETCH_DOCUMENTS_COLLECTIONS_SUCCESS_WITHOUT_RESULTS,
  FETCH_LOGGED_USER_PAYMENT_FAILURE,
  FETCH_LOGGED_USER_PAYMENT_REQUEST,
  FETCH_LOGGED_USER_PAYMENT_SUCCESS,
  FETCH_PAYMENT_FAILURE,
  FETCH_PAYMENT_REQUEST,
  FETCH_PAYMENT_SUCCESS,
  FETCH_TRACKING_PAGE_FAILURE,
  FETCH_TRACKING_PAGE_REQUEST,
  FETCH_TRACKING_PAGE_SUCCESS,
  FETCH_TRACKING_PAGE_SUCCESS_WITHOUT_RESULTS,
  FETCH_USER_PAYMENT_FAILURE,
  FETCH_USER_PAYMENT_REQUEST,
  FETCH_USER_PAYMENT_SUCCESS,
  INITIATE_PAYMENT_REQUEST,
  INITIATE_PAYMENT_SUCCESS,
  UPDATE_PAYMENT_FAILURE,
  UPDATE_PAYMENT_REQUEST,
  UPDATE_PAYMENT_SUCCESS,
  UPLOAD_LRS_FAILURE,
  UPLOAD_LRS_REQUEST,
  UPLOAD_LRS_SUCCESS,
} from 'constants/payment';
import {
  FETCH_RECIPIENT_COUNTRIES_REQUEST,
  FETCH_RECIPIENT_COUNTRIES_SUCCESS,
  FETCH_RECIPIENT_FAILURE,
  FETCH_RECIPIENT_FROM_PAYMENT_FAILURE,
  FETCH_RECIPIENT_FROM_PAYMENT_REQUEST,
  FETCH_RECIPIENT_FROM_PAYMENT_SUCCESS,
  FETCH_RECIPIENT_REQUEST,
  FETCH_RECIPIENT_SUCCESS,
  FETCH_RECIPIENTS_FAILURE,
  FETCH_RECIPIENTS_REQUEST,
  FETCH_RECIPIENTS_SUCCESS,
} from 'constants/recipients';
import {
  CANCEL_RECURRING_RECEIVABLE_FAILURE,
  CANCEL_RECURRING_RECEIVABLE_REQUEST,
  CANCEL_RECURRING_RECEIVABLE_SUCCESS,
  CREATE_RECURRING_RECEIVABLE_FAILURE,
  CREATE_RECURRING_RECEIVABLE_REQUEST,
  CREATE_RECURRING_RECEIVABLE_SUCCESS,
  FETCH_USER_RECURRING_RECEIVABLES_FAILURE,
  FETCH_USER_RECURRING_RECEIVABLES_REQUEST,
  FETCH_USER_RECURRING_RECEIVABLES_SILENTLY_FAILURE,
  FETCH_USER_RECURRING_RECEIVABLES_SILENTLY_SUCCESS,
  FETCH_USER_RECURRING_RECEIVABLES_SUCCESS,
} from 'constants/recurringReceivables';
import {
  FETCH_SENDER_FAILURE,
  FETCH_SENDER_REQUEST,
  FETCH_SENDER_SUCCESS,
} from 'constants/sender';
import {
  FETCH_TRACKING_SETUP_DATA_FAILURE,
  FETCH_TRACKING_SETUP_DATA_REQUEST,
  FETCH_TRACKING_SETUP_DATA_SUCCESS,
} from 'constants/trackingSetup';
import {
  FETCH_EMBEDDED,
  FETCH_PUBLIC_KEY_FAILURE,
  FETCH_PUBLIC_KEY_REQUEST,
  FETCH_PUBLIC_KEY_SUCCESS,
} from 'constants/ui';
import {
  CARD_ACTIVE_PLANS_FAILURE,
  CARD_ACTIVE_PLANS_REQUEST,
  CARD_ACTIVE_PLANS_SUCCESS,
  CREATE_USER_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  FETCH_PAYMENT_METHODS_FAILURE,
  FETCH_PAYMENT_METHODS_REQUEST,
  FETCH_PAYMENT_METHODS_SUCCESS,
  FETCH_USER_FAILURE,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  LOGIN_USER_REQUEST,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER_REQUEST,
  REMOVE_CREDIT_CARD_FAILURE,
  REMOVE_NEW_CREDIT_CARD_FAILURE,
  REMOVE_NEW_CREDIT_CARD_SUCCESS,
  SAVE_CARD_FAILURE,
  SAVE_CARD_REQUEST,
  SAVE_CARD_SUCCESS,
  UPDATE_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
} from 'constants/user';
import { combineReducers } from 'redux';

type IsFetchingAction = {
  type: string;
  payload?: boolean;
};

export const recipient = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case FETCH_RECIPIENT_REQUEST:
    case FETCH_RECIPIENT_COUNTRIES_REQUEST:
    case FETCH_RECIPIENT_FROM_PAYMENT_REQUEST:
      return true;
    case FETCH_RECIPIENT_SUCCESS:
    case FETCH_RECIPIENT_FROM_PAYMENT_SUCCESS:
    case FETCH_RECIPIENT_FAILURE:
    case FETCH_RECIPIENT_FROM_PAYMENT_FAILURE:
    case FETCH_RECIPIENT_COUNTRIES_SUCCESS:
      return false;
    default:
      return state;
  }
};

export const recipients = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case FETCH_RECIPIENTS_REQUEST:
      return true;
    case FETCH_RECIPIENTS_SUCCESS:
    case FETCH_RECIPIENTS_FAILURE:
      return false;
    default:
      return state;
  }
};

export const sender = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case FETCH_SENDER_REQUEST:
      return true;
    case FETCH_SENDER_SUCCESS:
    case FETCH_SENDER_FAILURE:
      return false;
    default:
      return state;
  }
};

export const validateFields = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case VALIDATE_FIELDS_REQUEST:
      return true;
    case VALIDATE_FIELDS_SUCCESS:
      return false;
    default:
      return state;
  }
};

export const offers = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case FETCH_OFFERS_REQUEST:
      return true;
    case FETCH_OFFERS_SUCCESS:
    case FETCH_OFFERS_FAILURE:
      return false;
    default:
      return state;
  }
};

export const recurringOffers = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case FETCH_RECURRING_OFFERS_REQUEST:
      return true;
    case FETCH_RECURRING_OFFERS_SUCCESS:
    case FETCH_RECURRING_OFFERS_FAILURE:
      return false;
    default:
      return state;
  }
};

export const offer = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case FETCH_OFFER_REQUEST:
      return true;
    case FETCH_OFFER_SUCCESS:
    case FETCH_OFFER_FAILURE:
      return false;
    default:
      return state;
  }
};

export const payment = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case CREATE_PAYMENT_REQUEST:
    case FETCH_PAYMENT_REQUEST:
    case FETCH_USER_PAYMENT_REQUEST:
    case FETCH_LOGGED_USER_PAYMENT_REQUEST:
    case UPDATE_PAYMENT_REQUEST:
    case UPLOAD_LRS_REQUEST:
      return true;
    case CREATE_PAYMENT_SUCCESS:
    case FETCH_PAYMENT_SUCCESS:
    case FETCH_USER_PAYMENT_SUCCESS:
    case FETCH_LOGGED_USER_PAYMENT_SUCCESS:
    case FETCH_PAYMENT_FAILURE:
    case CREATE_PAYMENT_FAILURE:
    case FETCH_USER_PAYMENT_FAILURE:
    case FETCH_LOGGED_USER_PAYMENT_FAILURE:
    case UPDATE_PAYMENT_SUCCESS:
    case UPDATE_PAYMENT_FAILURE:
    case UPLOAD_LRS_SUCCESS:
    case UPLOAD_LRS_FAILURE:
      return false;
    default:
      return state;
  }
};

export const createPayment = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case CREATE_PAYMENT_REQUEST:
      return true;
    case CREATE_PAYMENT_SUCCESS:
    case CREATE_PAYMENT_FAILURE:
      return false;
    default:
      return state;
  }
};

export const order = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case CREATE_ORDER_REQUEST:
    case FETCH_ORDER_REQUEST:
    case UPDATE_ORDER_REQUEST:
    case FETCH_ORDER_OWNERSHIP_REQUEST:
    case ADD_COUPON_REQUEST:
    case DELETE_COUPON_REQUEST:
    case ADD_REDEEM_REWARDS_REQUEST:
    case DELETE_REDEEM_REWARDS_REQUEST:
      return true;
    case CREATE_ORDER_FAILURE:
    case CREATE_ORDER_SUCCESS:
    case FETCH_ORDER_FAILURE:
    case FETCH_ORDER_SUCCESS:
    case UPDATE_ORDER_FAILURE:
    case UPDATE_ORDER_SUCCESS:
    case UPDATE_OFFER_DISCOUNT_SUCCESS:
    case FETCH_ORDER_OWNERSHIP_FAILURE:
    case FETCH_ORDER_OWNERSHIP_SUCCESS:
    case ADD_COUPON_FAILURE:
    case DELETE_COUPON_FAILURE:
    case ADD_REDEEM_REWARDS_FAILURE:
    case DELETE_REDEEM_REWARDS_FAILURE:
      return false;
    default:
      return state;
  }
};

export const publicKey = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case FETCH_PUBLIC_KEY_REQUEST:
      return true;
    case FETCH_PUBLIC_KEY_FAILURE:
    case FETCH_PUBLIC_KEY_SUCCESS:
      return false;
    default:
      return state;
  }
};

export const paymentManagement = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case CANCEL_PAYMENT_REQUEST:
    case INITIATE_PAYMENT_REQUEST:
      return true;
    case CANCEL_PAYMENT_SUCCESS:
    case CANCEL_PAYMENT_FAILURE:
    case INITIATE_PAYMENT_SUCCESS:
      return false;
    default:
      return state;
  }
};

export const authentication = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case LOGIN_USER_REQUEST:
      return true;
    case LOGIN_USER_FAILURE:
    case LOGIN_USER_SUCCESS:
      return false;
    default:
      return state;
  }
};

export const logout = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case LOGOUT_USER_REQUEST:
      return true;
    case LOGIN_USER_SUCCESS:
      return false;
    default:
      return state;
  }
};

export const user = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case CREATE_USER_REQUEST:
    case UPDATE_USER_REQUEST:
    case FETCH_USER_REQUEST:
    case FETCH_PAYMENT_METHODS_REQUEST:
    case CARD_ACTIVE_PLANS_REQUEST:
    case SAVE_CARD_REQUEST:
      return true;
    case CREATE_USER_FAILURE:
    case UPDATE_USER_FAILURE:
    case FETCH_USER_FAILURE:
    case FETCH_PAYMENT_METHODS_FAILURE:
    case REMOVE_CREDIT_CARD_FAILURE:
    case CREATE_USER_SUCCESS:
    case UPDATE_USER_SUCCESS:
    case FETCH_USER_SUCCESS:
    case FETCH_PAYMENT_METHODS_SUCCESS:
    case CARD_ACTIVE_PLANS_SUCCESS:
    case CARD_ACTIVE_PLANS_FAILURE:
    case SAVE_CARD_SUCCESS:
    case SAVE_CARD_FAILURE:
    case REMOVE_NEW_CREDIT_CARD_SUCCESS:
    case REMOVE_NEW_CREDIT_CARD_FAILURE:
      return false;
    default:
      return state;
  }
};

export const geolocation = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case UPDATE_IP_COUNTRY_CODE_REQUEST:
      return true;
    case UPDATE_IP_COUNTRY_CODE_SUCCESS:
      return false;
    default:
      return state;
  }
};

export const documents = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case FETCH_TRACKING_PAGE_REQUEST:
    case DELETE_FILE_REQUEST:
      return true;
    case FETCH_TRACKING_PAGE_SUCCESS:
    case FETCH_TRACKING_PAGE_SUCCESS_WITHOUT_RESULTS:
    case FETCH_TRACKING_PAGE_FAILURE:
    case DELETE_FILE_SUCCESS:
      return false;
    default:
      return state;
  }
};

export const documentsCollections = (
  state = false,
  action: IsFetchingAction,
) => {
  switch (action.type) {
    case FETCH_DOCUMENTS_COLLECTIONS_REQUEST:
      return true;
    case FETCH_DOCUMENTS_COLLECTIONS_SUCCESS:
    case FETCH_DOCUMENTS_COLLECTIONS_SUCCESS_WITHOUT_RESULTS:
    case FETCH_DOCUMENTS_COLLECTIONS_FAILURE:
      return false;
    default:
      return state;
  }
};

export const embedded = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case FETCH_EMBEDDED:
      return action.payload;
    default:
      return state;
  }
};

export const createPaymentFromOrder = (
  state = false,
  action: IsFetchingAction,
) => {
  switch (action.type) {
    case CREATE_PAYMENT_FROM_ORDER_REQUEST:
      return true;
    case CREATE_PAYMENT_FROM_ORDER_SUCCESS:
    case CREATE_PAYMENT_FROM_ORDER_FAILURE:
      return false;
    default:
      return state;
  }
};

export const recurringReceivables = (
  state = false,
  action: IsFetchingAction,
) => {
  switch (action.type) {
    case FETCH_USER_RECURRING_RECEIVABLES_REQUEST:
    case CREATE_RECURRING_RECEIVABLE_REQUEST:
      return true;
    case FETCH_USER_RECURRING_RECEIVABLES_SUCCESS:
    case FETCH_USER_RECURRING_RECEIVABLES_FAILURE:
    case FETCH_USER_RECURRING_RECEIVABLES_SILENTLY_SUCCESS:
    case FETCH_USER_RECURRING_RECEIVABLES_SILENTLY_FAILURE:
    case CREATE_RECURRING_RECEIVABLE_SUCCESS:
    case CREATE_RECURRING_RECEIVABLE_FAILURE:
      return false;
    default:
      return state;
  }
};

export const recurringReceivableCancellation = (
  state = false,
  action: IsFetchingAction,
) => {
  switch (action.type) {
    case CANCEL_RECURRING_RECEIVABLE_REQUEST:
      return true;
    case CANCEL_RECURRING_RECEIVABLE_SUCCESS:
    case CANCEL_RECURRING_RECEIVABLE_FAILURE:
      return false;
    default:
      return state;
  }
};

export const trackingSetupData = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case FETCH_TRACKING_SETUP_DATA_REQUEST:
      return true;
    case FETCH_TRACKING_SETUP_DATA_SUCCESS:
    case FETCH_TRACKING_SETUP_DATA_FAILURE:
      return false;
    default:
      return state;
  }
};

export const academic = (state = false, action: IsFetchingAction) => {
  switch (action.type) {
    case FETCH_ACADEMIC_REQUEST:
      return true;
    case FETCH_ACADEMIC_SUCCESS:
    case FETCH_ACADEMIC_FAILURE:
      return false;
    default:
      return state;
  }
};

const isFetching = combineReducers({
  authentication,
  createPayment,
  createPaymentFromOrder,
  documents,
  embedded,
  geolocation,
  offer,
  offers,
  order,
  payment,
  paymentManagement,
  publicKey,
  recipient,
  recipients,
  recurringOffers,
  recurringReceivableCancellation,
  recurringReceivables,
  sender,
  trackingSetupData,
  user,
  validateFields,
  academic,
});

export { isFetching };
